import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const TwoRow = memo(({ label, subLabel }) => {
    const theme = useTheme();
    const displayLabel = label || getLiteral('label_placeholder_unamed_record');

    return (
        <div>
            <Text type="body" isTruncated useTooltip>
                {displayLabel}
            </Text>
            <Text
                type="body"
                color={theme.colors.utility.textSecondary}
                isTruncated
                useTooltip
                as="div"
            >
                {subLabel}
            </Text>
        </div>
    );
});

TwoRow.displayName = 'TwoRow';

TwoRow.propTypes = {
    label: PropTypes.node,
    subLabel: PropTypes.node,
};

export default TwoRow;
